module.exports = __webpack_public_path__ + "img/ic_order_cancel_icon.a1fb04f7.png";